import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert, Button, Card, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row } from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ParticlesAuth from '../AuthenticationInner/ParticlesAuth';
import { postJwtResetPassword } from '../../helpers/fakebackend_helper';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');

const ResetPasswordPage: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get('email') || '';
  const token = params.get('token') || '';
  const [success, setSuccess] = useState('');
  const [serverError, setServerError] = useState('');

  const form = useFormik({
    initialValues: { password: '', confirmPassword: '' },
    validationSchema: Yup.object({
      password: Yup.string().min(8, st('mat_khau_toi_thieu_8_ky_error')).matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).+$/, st('can_co_chu_hoa_chu_thuong_error')).required(st('vui_long_nhap_mat_khau_moi_error')),
      confirmPassword: Yup.string().oneOf([Yup.ref('password')], st('mat_khau_xac_nhan_khong_khop_error')).required(st('vui_long_xac_nhan_mat_khau_error_2')),
    }),
    onSubmit: async (values) => {
      setSuccess('');
      setServerError('');
      try {
        const response: any = await postJwtResetPassword({ email, token, newPassword: values.password, confirmPassword: values.confirmPassword });
        setSuccess(response?.message || st('dat_lai_mat_khau_thanh_cong_text'));
      } catch (error: any) {
        setServerError(error?.data?.message || error?.message || st('khong_the_dat_lai_mat_khau_text'));
      }
    },
  });

  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5"><Container><Row className="justify-content-center"><Col md={8} lg={6} xl={5}>
        <Card className="mt-4"><CardBody className="p-4">
          <div className="text-center mt-2"><h5 className="text-primary">{st('dat_lai_mat_khau_text')}</h5><p className="text-muted">{st('tao_mat_khau_moi_cho_tai_text')} {email || st('cua_ban_text')}.</p></div>
          {!email || !token ? <Alert color="danger">{st('lien_ket_dat_lai_mat_khau_message')}</Alert> : null}
          {serverError ? <Alert color="danger">{serverError}</Alert> : null}
          {success ? <Alert color="success">{success}</Alert> : null}
          {!success && email && token && <Form onSubmit={form.handleSubmit}>
            <div className="mb-3"><Label for="password">{st('mat_khau_moi_label')}</Label><Input id="password" name="password" type="password" value={form.values.password} onChange={form.handleChange} onBlur={form.handleBlur} invalid={!!(form.touched.password && form.errors.password)} /><FormFeedback>{form.errors.password}</FormFeedback></div>
            <div className="mb-3"><Label for="confirmPassword">{st('xac_nhan_mat_khau_label')}</Label><Input id="confirmPassword" name="confirmPassword" type="password" value={form.values.confirmPassword} onChange={form.handleChange} onBlur={form.handleBlur} invalid={!!(form.touched.confirmPassword && form.errors.confirmPassword)} /><FormFeedback>{form.errors.confirmPassword}</FormFeedback></div>
            <Button color="success" className="w-100" type="submit">{st('cap_nhat_mat_khau_button')}</Button>
          </Form>}
          {success && <Link className="btn btn-success w-100" to="/login">{st('den_trang_dang_nhap_button')}</Link>}
        </CardBody></Card>
      </Col></Row></Container></div>
    </ParticlesAuth>
  );
};

export default ResetPasswordPage;
